import React from 'react'
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import WarningIcon from '@material-ui/icons/Warning';
import Modal from '@material-ui/core/Modal'
import { makeStyles } from "@material-ui/core/styles";
import { MAX_ZONES_ALLOWED_IN_MAP } from '../../constants'
import './style.css'

const useStyles = makeStyles(theme => ({
    root: {
      color: theme.palette.warning.main
    }
  }));

const AlertModal = ({ isOpen, onClose }) => {
    const classes = useStyles()
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
        >
            <Card className="alert-modal-card-wrapper">
                <div className="modal-success-content-wrapper">
                    <WarningIcon classes={{ root: classes.root }} style={{ fontSize: 80 }}/>
                    <h3>This Project has more than {MAX_ZONES_ALLOWED_IN_MAP} Zones</h3>
                    <p>This service can display up to {MAX_ZONES_ALLOWED_IN_MAP} Zones on the map</p>
                    <Button onClick={onClose}>
                        I Understand        
                    </Button>
                </div>
            </Card>
        </Modal>
    )
}

export default AlertModal